import { FC } from 'react';

type PageLoaderProps = { label: string };

/** Simple page loader (fallback) */
export const PageLoader: FC<PageLoaderProps> = ({ label }) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: 'var(--app-height)',
      color: '#4E1D10',
    }}
  >
    {label}
  </div>
);
